import { FC } from "react";
import DeprecatedTagButton from "../../../components/features/DeprecatedTagButton/index";
import FileHelper from "../../../helpers/FileHelper";
import styles from "./styles.scss";

interface FileNamesProps {
  karteFileAttachments?: File[];
  setKarteFileAttachments: (value: File[]) => void;
}

export const FileNames: FC<FileNamesProps> = ({
  karteFileAttachments,
  setKarteFileAttachments,
}) => {
  if (!karteFileAttachments) {
    return null;
  }

  return (
    <>
      {karteFileAttachments.map((attachment: File, i: number) => (
        <div
          className={styles.filename}
          key={`StudentKarteForm-attachmentNames-${i}`}
        >
          <DeprecatedTagButton
            label={FileHelper.truncateFilename(attachment.name, 30)}
            iconName="icon-close-x"
            theme="lightgray"
            onClick={handleFileDelete(
              karteFileAttachments,
              setKarteFileAttachments,
              i,
            )}
          />
        </div>
      ))}
    </>
  );
};

const handleFileDelete =
  (
    karteFileAttachments: File[] | undefined,
    setKarteFileAttachments: (value: File[]) => void,
    index: number,
  ) =>
  () => {
    if (!karteFileAttachments) {
      return;
    }

    const updatedAttachments = [...karteFileAttachments];
    updatedAttachments.splice(index, 1);
    setKarteFileAttachments(updatedAttachments);
  };
